import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, CircularProgress } from '@material-ui/core';
import { ProjectQualityMetricsDTO } from '../../DTO/ProjectMetrics';
import * as Api from '../../services';
import ProjectMetricsDisplay from './ProjectMetricsDisplay';

interface ProjectCardProps {
  descriptor: any;
  token: string;
}

const ProjectCard: React.FC<ProjectCardProps> = React.memo(({ descriptor, token }) => {
  const [metrics, setMetrics] = useState<ProjectQualityMetricsDTO | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    setMetrics(null);
    setError(null);

    if (!descriptor) {
      setError('No project descriptor was provided');
      return;
    }

    setLoading(true);

    (async () => {
      try {
        const data = await Api.apiPost<ProjectQualityMetricsDTO>('/api/project-metrics', token, { descriptor });
        if (!mounted) return;
        setMetrics(data);
      } catch (err: any) {
        if (!mounted) return;
        setError(err?.message || 'Failed to load project metrics');
        setMetrics(null);
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [descriptor, token]);

  return (
    <Paper style={{ paddingLeft: 24 , paddingBottom: 24, paddingTop: 8, paddingRight: 24 }}>
      <Box mt={2} display="flex" justifyContent="center">
        <Box width="100%" maxWidth={1200}>
          {loading && (
            <Box display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={28} />
            </Box>
          )}
          {error && !loading && (
            <Box mt={2}>
              <Typography variant="body2" color="error">{error}</Typography>
            </Box>
          )}
          {metrics !== null && !loading && !error && (
            <ProjectMetricsDisplay metrics={metrics} />
          )}
        </Box>
      </Box>
    </Paper>
  );
});

export default ProjectCard;
